// extracted by mini-css-extract-plugin
export var popper = "_84-0";